
document.addEventListener('DOMContentLoaded' , () =>{
	if(document.querySelector('.essence-sub-page')){
		if(document.querySelector('.js-essence-sub-swiper')){
			const subSwiper = document.querySelectorAll('.js-essence-sub-swiper');

			subSwiper.forEach(el => {
				let _subSwiper = new Swiper(el, {
					loop: true,
					autoplay: {
						delay: 3000,
					},
					loopedSlides: 1,
					loopAdditionalSlides: 1,
					slidesPerView: 1,
					spaceBetween: 20,
					initialSlide: 1,
					observer: true,
					observeParents: true,
					breakpoints: {
						768: {
							loop: true,
							slidesPerView: 2,
							spaceBetween: 48,
						},
					},
				});
			});
		}

		if(document.querySelector('.js-btn-tab')){
			const btnEssenceTab = document.querySelectorAll('.js-btn-tab');

			btnEssenceTab.forEach(function(el){
				let btnEssenceTabArray = Array.from(el.parentNode.parentNode.querySelectorAll('.js-btn-tab'));

				el.addEventListener('click' , function(e){
					btnEssenceTabArray.forEach(function(el){
						el.classList.remove('active');
					});
					el.classList.add('active');
				});
			})
		}

		if(document.querySelector('.ani')){
			$(window).on('scroll load' ,function(){
				$('.ani').each(function(){
					var bOject= $(this).offset().top + $(this).outerHeight()/5;
					var bWindow= $(window).scrollTop()+$(window).height();
					
					if(bOject<bWindow){
						$(this).addClass('show')
					}else{
						$(this).removeClass('show')
					}
				});
			}); 
		}
	}

	if(document.querySelector('.essence-leadfreeBrass-page')){
		if(document.querySelector('.js-essence-card-swiper')){
			let cardSwiper = document.querySelectorAll('.js-essence-card-swiper');

			cardSwiper.forEach(el => {
				let _cardSwiper = new Swiper(el, {
					loop: true,
					autoplay: {
						delay: 3000,
					},
					loopedSlides: 1,
					loopAdditionalSlides: 1,
					slidesPerView: 1,
					spaceBetween: 20,
					initialSlide: 1,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: el.parentElement.querySelector(".common-swiper-next"),
						prevEl: el.parentElement.querySelector(".common-swiper-prev"),
					},
					breakpoints: {
						768: {
							slidesPerView: 'auto',
							spaceBetween: 0,
						},
					},
				});
			});
		}
	}

	if(document.querySelector('.essence-finishing-page')){
		if(document.querySelector('.js-essence-card-swiper')){
			let cardSwiper = document.querySelectorAll('.js-essence-card-swiper');

			cardSwiper.forEach(el => {
				let thumbEl = el.closest('.card-slide')
					.nextElementSibling.querySelector('.js-essence-card-thumb-swiper');

				//card-thumb-slide
				let thumbSwiper = new Swiper(thumbEl, {
					slidesPerView: 'auto',
					watchSlidesProgress: true,
					slideToClickedSlide: true,
				});

				//card-slide
				let _cardSwiper = new Swiper(el, {
					loop: true,
					autoplay: {
						delay: 3000,
					},
					loopedSlides: 1,
					loopAdditionalSlides: 1,
					slidesPerView: 1,
					spaceBetween: 20,
					initialSlide: 1,
					observer: true,
					observeParents: true,
					navigation: {
						nextEl: el.parentElement.querySelector(".common-swiper-next"),
						prevEl: el.parentElement.querySelector(".common-swiper-prev"),
					},
					thumbs: {
						swiper: thumbSwiper,
					},
					breakpoints: {
						768: {
							slidesPerView: 'auto',
							spaceBetween: 0,
						},
					},
				});
			});
		}
	}
});
